import { gridOverlayStyle } from './gridOverlay';

// Pale blue with soft glows on either side, blending into white at the bottom
export const GRID_BACKDROP_BG = {
    backgroundColor: '#FFFFFF',
    backgroundImage: [
        'radial-gradient(520px 420px at 12% 45%, rgba(120,179,243,0.22), transparent 70%)',
        'radial-gradient(520px 420px at 90% 35%, rgba(120,179,243,0.24), transparent 70%)',
        'linear-gradient(#F6FBFF 0%, #F6FBFF 55%, #FFFFFF 100%)',
    ].join(', '),
};

// Soft grid that sits strongest at the sides, clears behind centred content, and fades out toward the bottom
export const GRID_BACKDROP_OVERLAY = gridOverlayStyle({
    color: 'rgba(120,179,243,0.22)',
    size: 80,
    edgeFade: false,
    extraMasks: ['linear-gradient(#000 45%, transparent 100%)'],
    gaps: [
        [50, 30, 160, 420],
        [50, 95, 120, 300],
    ],
});

// Full-width band behind the top of a page. The page wrapper needs `relative isolate bg-white`
// so this sits above the white but below the page content.
export default function GridBackdrop({ height = 'h-[900px]' }) {
    return (
        <div className={`absolute inset-x-0 top-0 -z-10 pointer-events-none ${height}`} style={GRID_BACKDROP_BG} aria-hidden="true">
            <span className="absolute inset-0" style={GRID_BACKDROP_OVERLAY} />
        </div>
    );
}
